import { render } from "./AddSegment.vue?vue&type=template&id=1d639c4c&scoped=true"
import script from "./AddSegment.vue?vue&type=script&lang=js"
export * from "./AddSegment.vue?vue&type=script&lang=js"

import "./AddSegment.vue?vue&type=style&index=0&id=1d639c4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d639c4c"]])

export default __exports__